<template>
  <v-btn v-bind="$attrs" @click="download" color="success" :loading="loading"><v-icon class="pr-1">fas fa-file-excel</v-icon> Скачать</v-btn>
</template>

<script>
import {downloadBlobFile} from "@/utils/pureFunctions";

export default {
  name: 'DownloadExcelCredits',
  props: {
    filter: {
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async download() {
      this.loading = true
      try {
        const {data} = await this.$http.get('admin/credits/excel', {
          params: {...this.filter},
          responseType: 'blob'
        })
        downloadBlobFile(data)
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.loading = false
      }
    }
  }
}
</script>